import React, {Component} from 'react';
import {Tabs,Tab,Grid,Cell,Card,CardTitle,CardText,CardActions,Button,CardMenu,IconButton} from 'react-mdl';

class Projects extends Component{
    constructor(props){
      super(props);
      this.state={
        activeTab : 0
      };
    }

    toggleCategories = ()=>{
      /*React*/
      if(this.state.activeTab === 0)
      {
        return(
          <div className = "project-grid">
          {/*Project 1*/}
          <Card shadow={5} style={{width: '350px', margin: 'auto'}}>
            <CardTitle style={{color: 'black', height: '176px', background:
            'url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUOVv8jYLsSAgZcMjY9TrDHeM0krX9TPOM4DQbeQbjJsi1F8xR) center / cover'}}>Weather Finder</CardTitle>
            <CardText>
              An web-app to find weather condition descriptions of a particular location with React-router for loadings.
            </CardText>
            <CardActions border>
              <Button colored href="https://github.com/coderperfect/weather-app" target="_blank">Github</Button>
              <Button colored href="https://codepen.io/coderperfect/pen/jpvVvp" target="_blank">CodePen</Button>
              <Button colored href="https://coderperfect.github.io/weather-app/" target="_blank">Live Demo</Button>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          </div>

        );
      }
      // /*Java*/
      // else if(this.state.activeTab === 3)
      // {
      //   return(
      //     <Card shadow={5} style={{width: '350px', margin: 'auto'}}>
      //       <CardTitle style={{color: 'black', height: '176px', background:
      //       'url(https://t4.ftcdn.net/jpg/01/29/38/43/240_F_129384345_7vzTDmiB72DPtMbefouBe5w72Et3DMwB.jpg) center / cover'}}>Java Project #1</CardTitle>
      //       <CardText>
      //         Working on it.
      //       </CardText>
      //       <CardActions border>
      //         <Button colored>Github</Button>
      //         <Button colored>CodePen</Button>
      //         <Button colored>Live Demo</Button>
      //       </CardActions>
      //       <CardMenu style={{color: '#fff'}}>
      //         <IconButton name="share" />
      //       </CardMenu>
      //     </Card>
      //   );
      // }
      /*ML*/
      else if(this.state.activeTab === 1)
      {
        return(
          <Card shadow={5} style={{width: '350px', margin: 'auto'}}>
            <CardTitle style={{color: 'black', height: '176px', background:
            'url(http://www.utdallas.edu/~abg160130/Tensorflow.jpg) center / cover'}}>Credit Card Fraud Detector</CardTitle>
            <CardText>
            Credit Card Frauds can be very subtle and at the same time large scale hazard. So here is an app Using outlier detection algorithms IsolationForest of numpy.ensemble to find malicious transactions red-handed.
            </CardText>
            <CardActions border>
              <Button colored href="https://github.com/coderperfect/Credit-Card-Fraud-Detector" target="_blank">Github</Button>
              {/* <Button colored>CodePen</Button>
              <Button colored>Live Demo</Button> */}
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
        );
      }
      /*Javascript*/
      // else if(this.state.activeTab === 2)
      // {
      //   return(
      //     <Card shadow={5} style={{width: '350px', margin: 'auto'}}>
      //       <CardTitle style={{color: 'black', height: '176px', background:
      //       'url(http://www.acadecap.org/wp-content/uploads/2016/07/Javascript.png) center / cover'}}>JS Project #1</CardTitle>
      //       <CardText>
      //         Working on it.
      //       </CardText>
      //       <CardActions border>
      //         <Button colored>Github</Button>
      //         <Button colored>CodePen</Button>
      //         <Button colored url="https://coderperfect.github.io/weather-app">Live Demo</Button>
      //       </CardActions>
      //       <CardMenu style={{color: '#fff'}}>
      //         <IconButton name="share" />
      //       </CardMenu>
      //     </Card>
      //   );
      // }
    }

    render(){
        return(
        <div>
            <Tabs activeTab={this.state.activeTab} onChange={(tabId) => this.setState({activeTab:tabId})} ripple>
            <Tab>React</Tab>
            <Tab>ML</Tab>
            {/* <Tab>JavaScript</Tab>
            <Tab>Java</Tab> */}
            </Tabs>

            <Grid>
            <Cell col={12}>
              <div> {this.toggleCategories()} </div>
            </Cell>
            </Grid>

            </div>
        );
    }
}

export default Projects;



// WEBPACK FOOTER //
// ./src/Components/projects.js